import { useEffect, useState } from "react";
import { StudentLayout } from "@/components/Layouts";
import { Card, CardContent } from "@/components/ui/card";
import { EmptyState } from "@/components/EmptyState";
import { Megaphone } from "lucide-react";
import api from "@/lib/api";

export default function StudentAnnouncements() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/announcements").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  return (
    <StudentLayout title="Announcements">
      <div className="mb-5">
        <h1 className="text-3xl font-heading font-bold tracking-tight">Announcements</h1>
        <p className="mt-2 text-muted-foreground">Latest announcements from the Maahad Bursa admin.</p>
      </div>
      {items.length === 0 ? (
        <EmptyState icon={Megaphone} title="No announcements" description="There are no announcements at this time." />
      ) : (
        <div className="space-y-3">
          {items.map((a) => (
            <Card key={a.id} className="glass-card" data-testid={`ann-${a.id}`}>
              <CardContent className="p-5">
                <div className="flex items-center gap-2 mb-1.5">
                  <Megaphone className="h-3.5 w-3.5 text-primary" />
                  <span className="text-xs text-muted-foreground">{a.created_at?.slice(0, 10)}</span>
                </div>
                <h3 className="font-heading font-semibold text-base">{a.title}</h3>
                <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{a.message}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </StudentLayout>
  );
}
